"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

exports.__esModule = true;
exports.createPalette = void 0;

var lodash_1 = require("lodash");

var colors_1 = require("./colors");

var palette = __assign(__assign({}, colors_1.colors), {
  text: {
    primary: colors_1.colors.gray80,
    secondary: colors_1.colors.gray70
  },
  background: {
    "default": colors_1.colors.white,
    paper: colors_1.colors.gray20,
    shadow: colors_1.colors.gray50,
    dimmed: colors_1.colors.gray10
  }
});

exports.createPalette = function (options) {
  var newColors = (options === null || options === void 0 ? void 0 : options.colors) || {};
  return lodash_1.merge({}, palette, options, newColors);
};